

//*************************DO NOT MODIFY**************************
//
//THESE FILES ARE AUTOGENERATED WITH TYPEWRITER AND ANY MODIFICATIONS MADE HERE WILL BE LOST
//PLEASE VISIT http://frhagn.github.io/Typewriter/ TO LEARN MORE ABOUT THIS VISUAL STUDIO EXTENSION
//
//*************************DO NOT MODIFY**************************
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ActualiteModel } from '../models/ActualiteModel';
import { ActualiteForListModel } from '../models/ActualiteForListModel';

@Injectable({
   providedIn: 'root'
})
export class ActualiteApiService {
    constructor(private _httpClient: HttpClient) { }        
    
    // get: api/Actualite/get?actualiteId=${actualiteId}
    get(actualiteId: number): Observable<ActualiteModel> {
        var _Url = `api/Actualite/get?actualiteId=${actualiteId}`;
            return this._httpClient.get<ActualiteModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Actualite/getActualitesAdmin
    getActualitesAdmin(): Observable<ActualiteForListModel[]> {
        var _Url = `api/Actualite/getActualitesAdmin`;
            return this._httpClient.get<ActualiteForListModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Actualite/getActualitesUser?etablissementId=${etablissementId}
    getActualitesUser(etablissementId: number): Observable<ActualiteModel[]> {
        var _Url = `api/Actualite/getActualitesUser?etablissementId=${etablissementId}`;
            return this._httpClient.get<ActualiteModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/Actualite/getLastActualiteForUser?etablissementId=${etablissementId}
    getLastActualiteForUser(etablissementId: number): Observable<ActualiteModel> {
        var _Url = `api/Actualite/getLastActualiteForUser?etablissementId=${etablissementId}`;
            return this._httpClient.get<ActualiteModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // post: api/Actualite/delete?id=${id}
    delete(id: number): Observable<boolean> {
        var _Url = `api/Actualite/delete?id=${id}`;
            return this._httpClient.post<boolean>(_Url, id).pipe(catchError(this.handleError));
    }
    
    // post: api/Actualite/save
    save(actualiteModel: ActualiteModel): Observable<ActualiteModel> {
        var _Url = `api/Actualite/save`;
            return this._httpClient.post<ActualiteModel>(_Url, actualiteModel).pipe(catchError(this.handleError));
    }
    
    // Utility
    private handleError(error: HttpErrorResponse) {
        console.error(error);
        let customError: string = "";
        if (error.error) {
            customError = error.status === 400 ? error.error : error.statusText
        }
        return throwError(customError || 'Server error');
    }
}
